import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { User, Bell } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72034c2-4f95-4f18-be74-1d29b1871fdc/artifacts/djdyqu9t_IMG_1381.png";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TopHeader() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [unreadNotifs, setUnreadNotifs] = useState(0);

  const fetchUnread = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/notifications/unread-count`, { withCredentials: true });
      setUnreadNotifs(data.count || 0);
    } catch {}
  }, []);

  useEffect(() => {
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, [fetchUnread]);

  return (
    <header
      data-testid="top-header"
      className="fixed top-0 left-0 right-0 bg-[#F5EEDB]/85 backdrop-blur-2xl border-b border-[#5B3E2E]/8 z-50 flex items-center justify-between px-4 h-[calc(3.5rem+env(safe-area-inset-top))] pt-[env(safe-area-inset-top)]"
    >
      <button className="flex items-center gap-2.5" onClick={() => navigate("/app/feed")}>
        <img src={LOGO_URL} alt="Refugium" className="w-8 h-8 rounded-full shadow-sm" />
        <span className="font-heading text-lg text-[#5B3E2E] tracking-tight">Refugium</span>
      </button>
      <div className="flex items-center gap-2">
        <button
          data-testid="notifications-button"
          onClick={() => navigate("/app/notifications")}
          className="relative w-8 h-8 rounded-full bg-[#5B3E2E]/8 flex items-center justify-center hover:bg-[#5B3E2E]/15 transition-colors"
        >
          <Bell size={16} strokeWidth={1.5} className="text-[#5B3E2E]/60" />
          {unreadNotifs > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] bg-[#E48D57] text-white text-[9px] font-bold rounded-full flex items-center justify-center px-1">
              {unreadNotifs > 9 ? "9+" : unreadNotifs}
            </span>
          )}
        </button>
        <button
          data-testid="profile-button"
          onClick={() => navigate("/app/profile")}
          className="w-8 h-8 rounded-full bg-[#5B3E2E]/8 flex items-center justify-center hover:bg-[#5B3E2E]/15 transition-colors overflow-hidden"
        >
          {user?.avatar_url ? (
            <img src={`${process.env.REACT_APP_BACKEND_URL}${user.avatar_url}`} alt="" className="w-8 h-8 rounded-full object-cover" />
          ) : (
            <User size={16} strokeWidth={1.5} className="text-[#5B3E2E]/60" />
          )}
        </button>
      </div>
    </header>
  );
}
